import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import { func, bool } from 'prop-types';

import styles from "./styles.scss";

export default class Footer extends Component {
  static propTypes = {
    onApply: func,
    onCancel: func,
    disableApply: bool
  }

  render() {
    const { onApply, onCancel, disableApply } = this.props;

    return (
      <div className={styles["footer"]}>
        <Button
          data-test="formCancelBtn"
          color="primary"
          onClick={onCancel}
        >
          Cancel
        </Button>
        <Button
          data-test="formApplyBtn"
          variant="contained"
          color="primary"
          onClick={onApply}
          disabled={disableApply}
        >
          Apply
        </Button>
      </div>
    )
  }
}